import { useState } from "react";

export default function BlockText({ block, setBlocks, updateBlock, className, isEditing, settingsFunnel }) {

    if(block.content == null){
        block.content = '<h3 class="ql-align-center"><strong>Vamos começar</strong></h3><p class="ql-align-center">Utilize esse componente para adicionar textos.</p>';
    }
 
    let editedContent = block.content;
    
    // The original code does not mutate editedContent because String.prototype.replace returns a new string, it does not modify in place.
    // You need to assign the result of each replace back to editedContent:
    editedContent = editedContent.replace(/ql-align-center/g, "text-center");
    editedContent = editedContent.replace(/ql-align-right/g, "text-right");
    editedContent = editedContent.replace(/ql-align-justify/g, "text-justify");
    editedContent = editedContent.replace(/ql-align-left/g, "text-left");

    // Ensure we have a proper font family with fallbacks
    const fontFamily = settingsFunnel?.font || 'Inter, sans-serif';

    return (
      <div className={`rounded-xl w-full ${className || ''}`}>
        <div className="w-full">
          <div id={`text-${block.id}`}
            className={`text-lg ql-editor `} 
            style={{ 
              color: settingsFunnel?.textColor || '#222222', 
              fontFamily: fontFamily,
              fontDisplay: 'swap',
              pointerEvents: 'none'
            }}
            dangerouslySetInnerHTML={{ __html: editedContent || '' }}
          ></div>
        </div>
      </div>
    );
  
}